// extracted by mini-css-extract-plugin
export default {"card":"McBQECdTbWGspSh6FLcV","deleteAction":"UMkBkmFqB9N5Qe6D0Bbi","offers":"ISIwpkYi0vtGohark4Z7","actions":"_jFMg7BmPj5_ibUDXkKl"};